import React from 'react'
import { Modal } from '@material-ui/core'
import { Button } from '@resiliatech/birdsong'
import {
  DeleteTaskContentContainer,
  FlexRowColumn,
  TaskModalButtonContainer,
  TaskModalHeader,
  Text,
} from './TaskModal.styled'

type DeleteTaskModalProps = {
  isOpen: boolean
  onClose: () => void
  onDeleteTask: (taskId: number) => Promise<void>
  taskId: number
}

export const DeleteTaskModal = ({
  isOpen,
  onClose,
  onDeleteTask,
  taskId,
}: DeleteTaskModalProps) => (
  <Modal
    open={isOpen && !!taskId}
    onClose={onClose}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    disableEnforceFocus
  >
    <DeleteTaskContentContainer>
      <TaskModalHeader>Delete Task</TaskModalHeader>
      <FlexRowColumn>
        <Text>Are you sure you want to delete this task?</Text>
        <Text>
          Team members that are assigned to this task will not be able to see it
          anymore.
        </Text>
      </FlexRowColumn>
      <TaskModalButtonContainer>
        <Button
          label='Cancel'
          onClick={onClose}
          type='button'
          variant='tertiary'
        />
        <Button
          label='Delete'
          onClick={() => onDeleteTask(taskId)}
          type='button'
          variant='primary'
        />
      </TaskModalButtonContainer>
    </DeleteTaskContentContainer>
  </Modal>
)
